module.exports = __webpack_public_path__ + "img/apply-eval-icon.80ddbe96.png";